import React from 'react';
import { NavigationContainer, PrevButton, NextButton } from './Styles';

export default function FormNavigation({ currentStep, isSubmitting, onPrev, onNext }) {
    return (
        <NavigationContainer>
            <PrevButton
                type="button"
                onClick={onPrev}
                $disabled={currentStep === 1 || isSubmitting}
            >
                Previous
            </PrevButton>

            <NextButton
                type="button"
                onClick={onNext}
                $loading={isSubmitting}
                disabled={isSubmitting}
            >
                {isSubmitting ? 'Submitting...' : (currentStep === 3 ? 'Submit' : 'Next')}
            </NextButton>
        </NavigationContainer>
    );
}